import { UrlMaker } from '@/utils/urlParamsMaker';
import Api, { baseURL, requestOptionsGET, requestOptionsPOST, requestOptionsPOSTWithArrayBody } from '../api';
import newFetch from '../utils/newFetch';

const getImportsXmlParams = (params, baseUrl) => {
  const { pageNumber, pageSize, createdAtStart, createdAtEnd, statusId, responsibleUserId, accessKey } = params;

  const urlMaker = UrlMaker(baseUrl);

  urlMaker.addKeyAndString('PageNumber', pageNumber);
  urlMaker.addKeyAndString('PageSize', pageSize);
  urlMaker.addKeyAndString('CreatedAtStart', createdAtStart);
  urlMaker.addKeyAndString('CreatedAtEnd', createdAtEnd);
  urlMaker.addKeyAndString('ResponsibleUserId', responsibleUserId);
  urlMaker.addKeyAndString('StatusId', statusId);
  urlMaker.addKeyAndString('AccessKeyCte', accessKey);

  return urlMaker.getURL();
};

const getCtesParams = (params, baseUrl) => {
  const {
    pageNumber,
    pageSize,
    importDateInitial,
    importDateEnd,
    authorizationDateInitial,
    authorizationDateEnd,
    numberCteInitial,
    numberCteEnd,
    senderId,
    accessKey,
    hasXml,
    boardingNumbers
  } = params;

  const urlMaker = UrlMaker(baseUrl);

  urlMaker.addKeyAndString('PageNumber', pageNumber);
  urlMaker.addKeyAndString('PageSize', pageSize);
  urlMaker.addKeyAndString('ImportDateStart', importDateInitial);
  urlMaker.addKeyAndString('ImportDateEnd', importDateEnd);
  urlMaker.addKeyAndString('AuthorizationDateStart', authorizationDateInitial);
  urlMaker.addKeyAndString('AuthorizationDateEnd', authorizationDateEnd);
  urlMaker.addKeyAndString('NumberCteStart', numberCteInitial);
  urlMaker.addKeyAndString('NumberCteEnd', numberCteEnd);
  urlMaker.addKeyAndString('SenderId', senderId);
  urlMaker.addKeyAndString('AccessKeyCte', accessKey);
  urlMaker.addKeyAndBoolean('HasXml', hasXml);
  urlMaker.addKeyAndArray('BoardingNumbers', boardingNumbers);

  return urlMaker.getURL();
};

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchImportsXml(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + getImportsXmlParams(params, Api.getUploadsXmls),
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  uploadXmlCte(_, payload) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.uploadXml, requestOptionsPOSTWithArrayBody(localStorage.getItem('accessToken'), payload))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getDetailsCteXml(_, cteXmlId) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getCteXmlDetails + cteXmlId, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  fetchListCtes(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + getCtesParams(params, Api.getAllCtes), requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  async downloadCteXml(_, payload = null) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.downloadXmlCtes,
        requestOptionsPOSTWithArrayBody(localStorage.getItem('accessToken'), payload)
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  async downloadCteXmlFilter(_, params = null) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + getCtesParams(params, Api.downloadXmlCteFilters), requestOptionsPOST(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  getSummaryStatusImport() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getCteXmlStatus, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getListDownloadCteXml() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getDownloadCteXmls, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((res) => {
          res.data;
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  downloadCteXmlsByInvoice(_, invoiceId) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + (Api.downloadCteXmlsByInvoice + invoiceId),
        requestOptionsPOST(localStorage.getItem('accessToken'))
      )
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  async downloadCteXmlZip(_, id) {
    const obj = requestOptionsGET(localStorage.getItem('accessToken'));
    const URL = baseURL + (Api.downloadCteXmlFileZip + id);

    try {
      const response = await fetch(URL, obj);
      if (response.status === 200) {
        const blob = await response.blob();
        const fileName = response.headers.get('file-name');
        const fileURL = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = fileURL;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        return { success: true };
      } else {
        return Promise.reject(response);
      }
    } catch (error) {
      console.error(error);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};